import { createFileRoute } from "@tanstack/react-router"

import { Articels } from "./-Articels"
import { ErrorState } from "./-Error"
import { knowledgebaseArticles } from "./-knowledgebaseArticles.query"
import { Loading } from "./-Loading"

const RouteComponent = () => {
  return <Articels />
}

export const Route = createFileRoute("/_chrome/knowledgebase/")({
  loader: ({ context }) => {
    void context.queryClient.query(knowledgebaseArticles)
  },
  component: RouteComponent,
  errorComponent: ErrorState,
  pendingComponent: Loading,
})
